import { Table, Tbody, Tr, Th } from '@chakra-ui/react';
import React from 'react';

import type { AddressTokenBalance } from 'types/api/address';

import { useI18n } from 'lib/i18n/context';
import { default as Thead } from 'ui/shared/TheadSticky';

import { ADDRESS_LIST_KEYS } from '../i18n';
import ERC20TokensTableItem from './ERC20TokensTableItem';

interface Props {
  data: Array<AddressTokenBalance>;
  top: number;
  isLoading: boolean;
}

const ERC20TokensTable = ({ data, top, isLoading }: Props) => {
  const { t } = useI18n();

  return (
    <Table>
      <Thead top={ top }>
        <Tr>
          <Th width="25%">{ t(ADDRESS_LIST_KEYS.fields.asset) }</Th>
          <Th width="20%">{ t(ADDRESS_LIST_KEYS.fields.contractAddress) }</Th>
          <Th width="13%" isNumeric>{ t(ADDRESS_LIST_KEYS.fields.price) }</Th>
          <Th width="27%" isNumeric>{ t(ADDRESS_LIST_KEYS.fields.quantity) }</Th>
          <Th width="15%" isNumeric>{ t(ADDRESS_LIST_KEYS.fields.value) }</Th>
        </Tr>
      </Thead>
      <Tbody>
        { data.map((item, index) => (
          <ERC20TokensTableItem key={ item.token.address + (isLoading ? index : '') } { ...item } isLoading={ isLoading }/>
        )) }
      </Tbody>
    </Table>
  );
};

export default ERC20TokensTable;
